import { Endpoints } from '@/core/models/endpoints.interface';

export const PERFORMANCE_CODE_ENDPOINTS: Pick<Endpoints, 'GET_ALL'> = {
   GET_ALL: () => `performance-code`,
};
